module.exports = new __parcel__URL__("chart-section.0f29c508.png").toString();